<template>

  <div>
    <component
        :companyConfig="getConfig"
        v-if=getConfig
        :is="getConfig.startStop.level"/>
  </div>

</template>

<script>
import {mapGetters} from 'vuex';
import Jobs from './../views/jobs/Jobs'

export default {
  components: {
    'jobs': Jobs,
  },
  data() {
    return {
      activeComponent: 'jobs'
    };
  },
  methods: {},
  computed: {
    ...mapGetters('company', [
      'getConfig'
    ]),
    ...mapGetters('users', [
      'getClaims'
    ]),

  },
  watch: {},
  created() {

  }
};
</script>

